import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";
import {MasterDataRepository} from "@/modules/masterData/adapter/MasterDataRepository";
import axios from "axios";
import {BranchOrderRepository} from "@/modules/branchOrder/adapter/BranchOrderRepository";

export class BranchOrderRestRepository implements BranchOrderRepository {


    public async sendB2BOrder(value:any):Promise<string> {
        const sid = this.auth.getAuthToken();
        const user = this.auth.getUserId();
        if (sid) {
            const data = {
                SID: sid,
                Auftragsnummer: value.NUMMER
            }
            const response = await axios.post(`${this.auth.getServiceUrl()}/B2BOrder/B2BBestellung_abschicken`, data);

            if (response.data.B2BBestellung_abschicken_response?.ServiceErrors) {
                throw new Error(response.data.B2BBestellung_abschicken_response.ServiceErrors[0].ERRORRECOMMENDATION);
            }

            return response.data.B2BBestellung_abschicken_response.UserMessage;
        } else {
            return Promise.reject();
        }
    }
    public async sendOrder(value:any):Promise<string> {
        const sid = this.auth.getAuthToken();
        const user = this.auth.getUserId();
        if (sid) {
            const data = {
                SID: sid,
                Bestellungsnummer: value.NUMMER
            }
            const response = await axios.post(`${this.auth.getServiceUrl()}/Filialbestellungen/Bestellung_abschicken`, data);

            if (response.data.Bestellung_abschicken_response?.ServiceErrors) {
                throw new Error(response.data.Bestellung_abschicken_response.ServiceErrors[0].ERRORRECOMMENDATION);
            }

            return response.data.Bestellung_abschicken_response.UserMessage;
        } else {
            return Promise.reject();
        }
    }
    public async printOrder(value:any, printall:boolean):Promise<string>{
        const sid = this.auth.getAuthToken();
        const user = this.auth.getUserId();
        if (sid) {
            const data = {
                SID: sid,
                Bestellungsnummer: value.NUMMER,
                NurBestellpositionen: printall ? 0 : 1
            }
            const response = await axios.post(`${this.auth.getServiceUrl()}/Filialbestellungen/get_URL_ReportFilialbestellung`, data);

            if (response.data.get_URL_ReportFilialbestellung_response?.ServiceErrors) {
                throw new Error(response.data.get_URL_ReportFilialbestellung_response.ServiceErrors[0].ERRORRECOMMENDATION);
            }else {
                return response.data.get_URL_ReportFilialbestellung_response.ImageURL;
            }

            return "";
        } else {
            return Promise.reject();
        }
    }
    private readonly auth: AuthenticationProvider;

    constructor(auth: AuthenticationProvider) {
        this.auth = auth;
    }


}
